export default __webpack_public_path__ + "static/10-mouth-watering-destinations-for-unashamed-foodies-germany-40d134ebcbdc611b99275535b4612c2a.jpg";